// extracted by mini-css-extract-plugin
export default {"collaborate":"CollaborateWrapper_collaborate__mrMyJ","body":"CollaborateWrapper_body__ctm-w","error":"CollaborateWrapper_error__Kfvlj","loading":"CollaborateWrapper_loading__LE+yT"};